// src/hooks/useCategories.js
import { useEffect, useState } from "react";
import { fetchCategoriesWithSubcategories } from "../services/categories";

export default function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        setLoading(true);
        const data = await fetchCategoriesWithSubcategories();
        if (mounted) setCategories(data);
      } catch (e) {
        if (mounted) setError(e?.message || "Failed to load categories");
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return { categories, loading, error };
}
